import {OrderedMap} from 'immutable';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Schema = OrderedMap<string, any>;
interface WebhookLayoutPlugin {
  wrapComponents: {
    info: () => () => null;
  };
  statePlugins: {
    spec: {
      wrapSelectors: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        definitions: (ori: () => OrderedMap<string, Schema>, system: any) => () => any;
      };
    };
  };
}

export default function WebhookLayoutPlugin(): WebhookLayoutPlugin {
  const baseSchemas = ['WebhookEnvelopeV0', 'WebhookMessageV0'];

  const customComparator = (value1: string, value2: string): number => {
    const isV0 = (value: string): boolean => baseSchemas.includes(value);

    if (isV0(value1) === isV0(value2)) {
      return value1.localeCompare(value2);
    }
    return isV0(value1) ? 1 : -1;
  };

  return {
    wrapComponents: {
      info: () => () => null,
    },
    statePlugins: {
      spec: {
        wrapSelectors: {
          definitions: (ori, system) => () =>
            ori()
              .filter(
                (value: Schema, key: string): boolean =>
                  baseSchemas.includes(key) || // Base schemas
                  (Boolean(value.getIn(['properties', 'type'])) && !value.get('deprecated')) // Non-deprecated message schemas
              )
              .sortBy((_, key) => key, customComparator), // Separate V0 webhooks
        },
      },
    },
  };
}
